import { render, staticRenderFns } from "./TermsToAcceptDialog.vue?vue&type=template&id=b0f26842&scoped=true"
import script from "./TermsToAcceptDialog.vue?vue&type=script&lang=js"
export * from "./TermsToAcceptDialog.vue?vue&type=script&lang=js"
import style0 from "./TermsToAcceptDialog.vue?vue&type=style&index=0&id=b0f26842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f26842",
  null
  
)

export default component.exports